import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/contact/page.tsx")